import moment from 'moment'
import { store } from '@/store'
import format from '@/helpers/format'
import { toInteger,get } from 'lodash'

// Função utilizada em algumas rotinas dos componentes de cargo para agregação
// import cargosDataTable from '@/components/Admin/Cargos/components/_cargoDataTablePrepare'
// return cargosDataTable(this.allCargos)
// return cargosDataTable(this.allCargos, this.cargoid)[0]

// Função utilizada em algumas rotinas dos componentes de cargo para agregação
// import detailsTablePrepare from '@/components/Admin/Cargos/components/_customerDetailsTablePrepare'
// return detailsTablePrepare(this.allCargos, this.cargoid, this.branchid)
// return detailsTablePrepare(this.allCargos, this.cargoid, this.branchid, this.events).details

export default {
  getAllCargosForReportSimple:
    (state, getters, rootState, rootGetters) =>
    () => {
      let returnObj = []
      const newDataFiltered = getters.getAllCargosFiltered.filter((item) => {
        return true
        // const allowedStatus = ['F', 'V', 'U']
        // if (allowedStatus.includes(item.cargo_status)) return true
        // else return false
      })

      newDataFiltered.forEach(async (cargo) => {
        // const dataSomated = cargosDataTable(newDataFiltered, cargo.cargo_id)[0]

        Object.keys(cargo.customers).forEach(async (indexCustumer) => {
          let customer = cargo.customers[indexCustumer]
          let truck = rootGetters['Trucks/getTruck'](cargo.truck_id)

          Object.keys(customer.invoices).forEach((indexInvoice) => {
            let invoice = customer.invoices[indexInvoice]

            let toPush = {
              branch_id: cargo.branch_id,
              branch_name: cargo.branch_id ? rootGetters['User/getCompanieBranchName'](cargo.branch_id) : '',

              cargo_id: cargo.cargo_id,
              cargo_status_id: cargo.cargo_status,
              cargo_status: cargo.cargo_status ? rootGetters['Cargos/getCargoStatusLabel'](cargo.cargo_status) : '',
              cargo_created_at: cargo.created_at ? moment.unix(cargo.created_at.seconds).format('DD/MM/YYYY HH:mm') : '',
              cargo_started_at: cargo.started_at ? moment.unix(cargo.started_at.seconds).format('DD/MM/YYYY HH:mm') : '',
              cargo_finished_at: cargo.finished_at ? moment.unix(cargo.finished_at.seconds).format('DD/MM/YYYY HH:mm') : '',
              cargo_traveled_time_s: cargo.finished_at ? Math.round((get(cargo, 'finished_at.seconds', 0) - get(cargo, 'started_at.seconds', 0))) : 0,
              cargo_created_by: cargo.created_by ? cargo.created_by.split(' ')[0] : '',
              cargo_total_customers: Object.values(cargo.customers).length,

              driver_name: cargo.started_by ? rootGetters['User/getDriverName'](cargo.started_by) : '',
              checker_name: cargo.checker ? cargo.checker : '',

              truck_id: cargo.truck_id ? cargo.truck_id : '',
              truck_model: truck.truck_model ? truck.truck_model : '',
              truck_cap_vol: truck.cap_volumes ? truck.cap_volumes : 0,
              truck_cap_weight: truck.cap_weight ? truck.cap_weight : 0,
              truck_cost_security: truck.cost_security ? truck.cost_security : 0,
              truck_cost_ipva: truck.cost_ipva ? truck.cost_ipva : 0,
              truck_cost_tracker: truck.cost_tracker ? truck.cost_tracker : 0,
              truck_cost_depreciation: truck.cost_depreciation ? truck.cost_depreciation : 0,
              truck_cost_others: truck.cost_others ? truck.cost_others : 0,
              truck_cost_othersdescriptions: truck.cost_othersdescriptions ? truck.cost_othersdescriptions : '',
              truck_cost_total: truck.cost_total ? truck.cost_total : 0,
              truck_traveled_km: cargo.finished_km ? Math.round((cargo.finished_km - cargo.started_km)) : 0,

              customer: customer.customer ? customer.customer : '',
              customer_city: customer.city ? customer.city : '',
              customer_neighborhood: customer.neighborhood ? customer.neighborhood : '',
              customer_state: customer.state ? customer.state : '',
              customer_status: customer.status ? rootGetters['Cargos/getCargoDeliveryLabels'](customer.status, customer) : '',
              canceled_reason: rootGetters['User/customerReasonDesc'](customer),
              canceled_notice: customer.canceled_notice ? customer.canceled_notice : '',

              delivered_info: customer.delivered_info ? customer.delivered_info : '',

              delivering_at: customer.delivering_at ? moment.unix(customer.delivering_at.seconds).format('DD/MM/YYYY HH:mm') : '',
              delivering_checkin_at: customer.delivering_checkin_at ? moment.unix(customer.delivering_checkin_at.seconds).format('DD/MM/YYYY HH:mm') : '',
              delivered_at: customer.delivered_at ? moment.unix(customer.delivered_at.seconds).format('DD/MM/YYYY HH:mm') : '',

              invoice: invoice.invoice ? invoice.invoice : '',
              invoice_ammount: invoice.total ? format(invoice.total, 'C') : format(0, 'C'),
              invoice_weight: invoice.weight ? format(invoice.weight, 'N') : format(0, 'N'),
              invoice_delivered_at: invoice.delivered_at ? moment.unix(invoice.delivered_at.seconds).format('DD/MM/YYYY HH:mm') : '',

              checked_log: customer.checked_log ? 'Sim' : 'Não',
              checked_log_by: customer.checked_log_at ? moment.unix(customer.checked_log_at.seconds).format('DD/MM/YYYY HH:mm') : '',
              checked_fin: customer.checked_fin ? 'Sim' : 'Não',
              checked_fin_by: customer.checked_fin_at ? moment.unix(customer.checked_fin_at.seconds).format('DD/MM/YYYY HH:mm') : '',
              checked_fin_at: customer.checked_fin_by ? customer.checked_fin_by.split(' ')[0] : '',

              comments: customer.comments ? rootGetters['User/getCustomerCommentsConcat'](customer) : '',
             }

            if (!invoice.status && customer.status) {
              toPush['invoice_status'] = toPush['customer_status']
            } else {
              toPush['invoice_status'] = invoice.status ? rootGetters['Cargos/getCargoDeliveryLabels'](invoice.status, invoice) : ''
            }

            if (!invoice.cancel_reason && customer.canceled_reason) {
              toPush['invoice_status_reason'] = toPush['canceled_reason']
            } else {
              toPush['invoice_status_reason'] = invoice.status === 'with_partial' ? rootGetters['User/withPartialReasonsConcat'](invoice) : invoice.cancel_reason ? rootGetters['User/cancellationReasonsDesc'](invoice.cancel_reason) : ''
            }

            if (!invoice.cancel_notice && customer.canceled_notice) {
              toPush['invoice_status_notice'] = `${toPush['canceled_notice']} | Motivo definido a nível de cliente`
            } else {
              toPush['invoice_status_notice'] = invoice.cancel_notice ? invoice.cancel_notice : ''
            }

            toPush['cargo_traveled_time_avg_s'] = Math.round((toPush.cargo_traveled_time_s / toPush.cargo_total_customers))

            returnObj.push(toPush)

          })
        })
      })
      return returnObj
    },
}
